const enum PaymentGateway {
  STRIPE = "stripe",
  ARCOPAY = "arcopay",
  ASTRAPAY = "astrapay",
  CLOUD_PAYMENTS = "cloud-payments",
}

export default PaymentGateway;
